<section class="h-full w-full min-h-0 flex flex-col" aria-labelledby="upload-csv-heading">
    <div class="flex h-full w-full max-w-3xl mx-auto flex-col justify-center gap-5 sm:gap-6">
        <header class="shrink-0 px-0.5">
            <h3 id="upload-csv-heading" class="text-base font-semibold text-primary">
                Upload CSV list
            </h3>
            <p class="text-sm leading-relaxed text-secondary">
                Download the monitoring template, add your creators, then upload the completed file to attach it to this
                brief.
            </p>
        </header>

        <div
            class="flex flex-col overflow-hidden rounded-lg bg-white shadow-sm card-container-pale p-4 sm:p-6 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10">
            <div class="flex min-h-0 flex-1 flex-col gap-5">
                <div class="min-h-0 flex-1">
                    <p id="upload-csv-drop-label" class="sr-only">
                        Upload your filled CSV or spreadsheet file
                    </p>
                    <div class="h-full w-full" aria-describedby="upload-csv-drop-label">
                        <atom-add-document (documentUploaded)="onDocumentUploaded($event)"></atom-add-document>
                    </div>
                </div>

                @if (savedUploadedFile()) {
                <p class="flex items-start gap-2.5 rounded-md border border-green-200 bg-green-50 px-3 py-2.5 text-sm text-green-900 dark:border-green-500/30 dark:bg-green-950/40 dark:text-green-100"
                    role="status" aria-live="polite">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 shrink-0 text-green-600 dark:text-green-400 mt-0.5" aria-hidden="true">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span>
                        <span class="font-medium text-green-900 dark:text-green-50">File ready.</span>
                        <span class="block mt-0.5 text-green-800/90 dark:text-green-100/90">You can submit your creator
                            list when you are finished.</span>
                    </span>
                </p>
                }
            </div>
        </div>

        <footer class="shrink-0 flex flex-col-reverse gap-3 sm:flex-row sm:justify-between sm:gap-3">
            <div class="flex flex-row gap-x-2 items-center justify-start">
                @if (!loading()) {
                <button (click)="closeCsv()" type="button"
                    class="secondary-button text-primary inline-flex flex-row items-center gap-x-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5">
                        <path d="m12 19-7-7 7-7" />
                        <path d="M19 12H5" />
                    </svg>
                    Cancel</button>
                }
            </div>


            <div class="flex flex-row gap-x-2 items-center justify-end">
                @if (loading()) {
                <span
                    class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
                    <svg aria-hidden="true"
                        class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor" />
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill" />
                    </svg>

                    Submitting List...
                </span>
                } @else {
                <button type="button" (click)="getTemplate($event)"
                    class="secondary-button inline-flex w-full items-center justify-center gap-2 sm:w-auto sm:min-w-44">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4 shrink-0" aria-hidden="true">
                        <path d="M12 15V3" />
                        <path d="m17 10-5 5-5-5" />
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    </svg>
                    Get template
                </button>
                <button type="button" (click)="submitList($event)" [disabled]="!savedUploadedFile()"
                    class="primary-button inline-flex w-full items-center justify-center gap-2 sm:w-auto sm:min-w-44">
                    Submit list
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4 shrink-0">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                </button>
                }

            </div>
        </footer>
    </div>
</section>